(function($, Drupal) {
  Drupal.behaviors.bokaTabsHideDisabledPeople = {
    attach(context) {
      once(
        "bokaTabsHideDisabledPeople",
        ".paragraph--type--tabs",
        context
      ).forEach(tabs => {
        const $tabs = $(tabs);
        const $firstPaneItem = $(
          ".tab-pane.--first-tab-content .paragraph--type--tab-item",
          $tabs
        );
        const $otherPanesItems = $(
          ".tab-pane:not(.--first-tab-content) .paragraph--type--tab-item",
          $tabs
        );
        if ($otherPanesItems.count === 0) {
          return;
        }
        $firstPaneItem.hide();
        const peopleItemClass = ".paragraph--type--people-item";
        const itemTitleClass = ".field--name-field-title";
        $(peopleItemClass, $firstPaneItem).each(function() {
          const $mainCard = $(this);
          const $mainTitle = $(itemTitleClass, $mainCard).first();
          let cardKeep = false;
          let cardUnpublished = false;
          if ($mainTitle) {
            $otherPanesItems.each(function() {
              const $testPaneItem = $(this);
              $(peopleItemClass, $testPaneItem).each(function() {
                const $testCard = $(this);
                const $testTitle = $(itemTitleClass, $testCard).first();
                if ($mainTitle.text().trim() === $testTitle.text().trim()) {
                  cardKeep = true;
                  if ($testPaneItem.hasClass("paragraph--unpublished")) {
                    cardUnpublished = true;
                  }
                }
              });
            });
          } else {
            cardKeep = true;
          }

          if (!cardKeep) {
            $mainCard.parent().hide();
          }
          if (cardUnpublished) {
            $mainCard.addClass("alert-danger");
          }
        });
        $firstPaneItem.show();
      });
    }
  };
})(jQuery, Drupal);
